<template>
    <div class="mine-list-container">
        <div class="mine-list" v-for="(list, i) in dataArray" :key="i">
            <main-list-cell v-for="(item, j) in list" :key="j" :model="item"
                @onCellClick="onCellClick"></main-list-cell>
        </div>
    </div>
</template>

<script>
import MainListCell from "./MainListCell.vue";

export default {
    components: {
        MainListCell
    },
    data() {
        return {
            dataArray: [
                [
                    {
                        icon: require('@img/mine-report.png'),
                        title: "报告记录",
                        iconWidth: 14,
                        iconHeight: 15
                    }
                ],
                [
                    {
                        icon: require('@img/mine-protocol.png'),
                        title: "用户协议",
                        iconWidth: 13,
                        iconHeight: 16
                    },
                    {
                        icon: require('@img/mine-privacy.png'),
                        title: "隐私协议",
                        iconWidth: 14,
                        iconHeight: 15
                    },
                    {
                        icon: require('@img/mine-exit.png'),
                        title: "退出登录",
                        iconWidth: 15,
                        iconHeight: 14
                    }
                ]
            ]
        };
    },
    methods: {
        onCellClick(title) {
            this.$emit("onCellClick", title);
        }
    }
};
</script>

<style lang="scss" scoped>
.mine-list-container {
    margin-top: 89px;
    .mine-list {
        background-color: white;
        border-radius: 6px;
        box-sizing: border-box;
        padding: 9px 21px 9px;
        margin-top: 12px;
    }
}
</style>